export function debounce<T extends (...args: any[]) => any>(
	func: T,
	delay: number = 0
): (...args: Parameters<T>) => void {
	let timeoutId: ReturnType<typeof setTimeout> | undefined;

	return function (this: ThisParameterType<T>, ...args: Parameters<T>): void {
		// eslint-disable-next-line @typescript-eslint/no-this-alias
		const context = this;
		clearTimeout(timeoutId);
		timeoutId = setTimeout(() => {
			func.apply(context, args);
		}, delay);
	};
};

export function throttle<T extends (...args: any) => any> (func: T, delay: number): (...args: Parameters<T>) => void {
	let timeoutId: NodeJS.Timeout | null = null;
	let lastArgs: Parameters<T> | null = null;
	let lastThis: ThisParameterType<T> | null = null;
	let lastExecutionTime = 0;

	return function (this: ThisParameterType<T>, ...args: Parameters<T>): void {
		const now = Date.now();
		lastArgs = args;
		// eslint-disable-next-line @typescript-eslint/no-this-alias
		lastThis = this;

		if (now - lastExecutionTime >= delay) {
			// Execute immediately if enough time has passed
			lastExecutionTime = now;
			func.apply(lastThis, lastArgs);
		} else if (!timeoutId) {
			// Set a timeout to execute after the delay if not already set
			timeoutId = setTimeout(() => {
				lastExecutionTime = Date.now();
				func.apply(lastThis, lastArgs);
				timeoutId = null;
			}, delay - (now - lastExecutionTime));
		}
	};
}

export function escapeHtml (str): string {
	const div = document.createElement('div');
	div.innerText = str;
	return div.innerHTML;
}
